import React, { useState, useEffect, useCallback, useRef } from "react"
import { Input } from "antd"
import { debounce } from "debounce"
import {
  IPolicyholder,
  policyholderSearchResultToPolicyholder
} from "platform-client/types"
import usePlatform from "contexts/platform/use-platform"

const { Search } = Input

export const SearchComponent: React.FunctionComponent<ISearchComponent> = (
  props
) => {
  const [isSending, setIsSending] = useState(false)
  const isMounted = useRef(true)
  const { policyholders } = usePlatform()

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  const sendRequest = useCallback(
    async (value: string) => {
      if (isSending) return

      setIsSending(true)
      props.setSearchLoading(true)

      if (value) {
        props.setSearchValue(value)

        const _policyholders = await policyholders.searchPolicyholders({
          searchTerm: value
        })

        if (_policyholders) {
          props.policyholdersUpdate(
            _policyholders.map(policyholderSearchResultToPolicyholder)
          )
        }

        props.setSearchLoading(false)
      } else if (!value) {
        props.setSearchValue(null)
        props.setSearchLoading(false)
      }

      if (isMounted.current) {
        setIsSending(false)
        props.setSearchLoading(false)
      }
    },
    [props, isSending, policyholders]
  )

  return (
    <Search
      style={{ width: 425 }}
      onSearch={debounce((value: string) => sendRequest(value), 200)}
      placeholder="search by name, email, or postcode"
      enterButton="Search"
      allowClear={true}
      defaultValue={props.searchValue || ""}
    />
  )
}

interface ISearchComponent {
  policyholdersUpdate: (data: IPolicyholder[] | undefined) => void
  setSearchValue: (value: string | null) => void
  setSearchLoading: (value: boolean) => void
  searchValue: string | undefined | null
}
